
// Create the dedicated axios instance for Finance
import axios, { HttpStatusCode } from "axios";
const axiosFinance = axios.create({
    baseURL: process.env.REACT_APP_FINANCE_BASE_URL,
});

// Request Interceptor
axiosFinance.interceptors.request.use(
    (config) => {
        // Get credentials from localStorage like the main interceptor
        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            config.headers["x-access-token"] = token;
            config.headers["user_id"] = userId;
        }
        return config;
    },
    (error) => {
        return Promise.reject({
            message: "Request error occurred",
            status: HttpStatusCode.InternalServerError,
            ...(error?.request || {}),
        });
    }
);

// Response Interceptor
axiosFinance.interceptors.response.use(
    (response) => {
        if (response.status >= HttpStatusCode.Ok && response.status <= 299) {
            return (
                response.data || {
                    error: false,
                    data: [],
                    message: "",
                }
            );
        } else {
            const errorData = response?.data || {
                error: true,
                status: response.status,
                data: [],
                message: "API error occurred",
            };
            return Promise.reject(errorData);
        }
    },
    (error) => {
        const backendMessage = error.response?.data?.message || error.response?.data?.error || "Response error occurred";
        return Promise.reject({
            message: backendMessage,
            status: error.response?.status || HttpStatusCode.InternalServerError,
            ...(error?.response || {}),
        });
    }
);

export default axiosFinance;
